import jQuery from 'jquery';

window.jQuery = jQuery;

var script = {
	name: 'PitchPrint',
	props: {
		apiKey: String,
		langCode: String,
		designId: String,
		display: String,
	},
	data: function () { return ({
		btnShowEditor: 'Customize',
		btnEditPr: 'Edit',
		btnResetPr: 'Reset',
		showCustomizeBtn: false,
		showEditBtn: false,
		showResetBtn: false,
		checkPPClientClass: 50,
		loading: true,
	}); },
	mounted: function mounted() {
      var clientScript = document.createElement('script');
      clientScript.setAttribute('src', 'https://pitchprint.io/rsc/js/client.js');
      document.head.appendChild(clientScript);
      this.init();
    },
    methods: {
		init: function init() {
			if (!this.checkPPClientClass) { return; }
			
			/* eslint-disable-next-line */
			if ( typeof PitchPrintClient === "undefined") {
				this.checkPPClientClass--;
				setTimeout(this.init, 500);
				return;
			} 
			
			/* eslint-disable-next-line */
			window.ppclient = new PitchPrintClient({
				apiKey: this.apiKey || '3dda9361ec74898ec376e970ffff891c',
				designId: this.designId || '8be2b573f4db5f6d6adc76bd9786a0f1',
				langCode: this.langCode || 'en',
				custom: true,
				mode: this.display || 'modal',
			});
			window.ppclient.on('app-validated', this.validate);
			window.ppclient.on('project-saved', this.projSaved);
		},
		projSaved: function projSaved(e) {
			this.showCustomizeBtn = false;
			this.showEditBtn = true;
			this.showResetBtn = true;
			this.$root.$emit('pitchprint-project-saved', e.data);
			// ToDo: set localStorage
		},
		validate: function validate() {
			//Function to run once the app is validated (ready to be used)
			this.showCustomizeBtn = true;				//Enable the Launch button
			this.loading = false;						//Hide the loader
		},
		showEditor: function showEditor() {
			window.ppclient.showApp();
		},
		doEditPr: function doEditPr() {
			window.ppclient.showApp();
		},
		doResetPr: function doResetPr() {
			// ToDo: clear localStorage
			window.location.reload();
		}
	}
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    var options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    var hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            var originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            var existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

var isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return function (id, style) { return addStyle(id, style); };
}
var HEAD;
var styles = {};
function addStyle(id, css) {
    var group = isOldIE ? css.media || 'default' : id;
    var style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        var code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                { style.element.setAttribute('media', css.media); }
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            var index = style.ids.size - 1;
            var textNode = document.createTextNode(code);
            var nodes = style.element.childNodes;
            if (nodes[index])
                { style.element.removeChild(nodes[index]); }
            if (nodes.length)
                { style.element.insertBefore(textNode, nodes[index]); }
            else
                { style.element.appendChild(textNode); }
        }
    }
}

/* script */
var __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", [
    _vm.loading
      ? _c("div", [
          _c("img", {
            attrs: {
              src: "https://pitchprint.io/rsc/images/loaders/spinner_new.svg"
            }
          })
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.showCustomizeBtn
      ? _c("input", {
          staticClass: "pp-editor-button",
          attrs: { value: _vm.btnShowEditor, type: "button" },
          on: { click: _vm.showEditor }
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.showEditBtn
      ? _c("input", {
          staticClass: "pp-editor-button",
          attrs: { value: _vm.btnEditPr, type: "button" },
          on: { click: _vm.doEditPr }
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.showResetBtn
      ? _c("input", {
          staticClass: "pp-editor-button",
          attrs: { value: _vm.btnResetPr, type: "button" },
          on: { click: _vm.doResetPr }
        })
      : _vm._e()
  ])
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  var __vue_inject_styles__ = function (inject) {
    if (!inject) { return }
    inject("data-v-2a68f847_0", { source: "\n.pp-editor-button {\n\tbackground: #56cfe1;\n\tborder: 0;\n\theight: 2.5rem;\n\tcolor: white;\n\ttext-transform: uppercase;\n\tfont-weight: bold;\n\tborder-radius: 4px;\n\tcursor: pointer;\n\tmargin-right: 10px;\n\tmin-width: 5rem;\n}\n", map: {"version":3,"sources":["/home/ec2-user/environment/vue-pitchprint/src/PitchPrint.vue"],"names":[],"mappings":";AAYA;CACA,mBAAA;CACA,SAAA;CACA,cAAA;CACA,YAAA;CACA,yBAAA;CACA,iBAAA;CACA,kBAAA;CACA,eAAA;CACA,kBAAA;CACA,eAAA;AACA","file":"PitchPrint.vue","sourcesContent":["<template>\n\t<div>\n\t\t<div v-if=\"loading\"><img src=\"https://pitchprint.io/rsc/images/loaders/spinner_new.svg\"></div>\n\t\t<input class=\"pp-editor-button\" v-if=\"showCustomizeBtn\" @click=\"showEditor\" :value=\"btnShowEditor\" type=\"button\"/>\n\t\t<input class=\"pp-editor-button\" v-if=\"showEditBtn\" @click=\"doEditPr\" :value=\"btnEditPr\" type=\"button\"/>\n\t\t<input class=\"pp-editor-button\" v-if=\"showResetBtn\" @click=\"doResetPr\" :value=\"btnResetPr\" type=\"button\"/>\n\t</div>\n</template>\n\n<script src=\"./pitchprint.js\"></script>\n\n<style type=\"text/css\">\n\t.pp-editor-button {\n\t\tbackground: #56cfe1;\n\t\tborder: 0;\n\t\theight: 2.5rem;\n\t\tcolor: white;\n\t\ttext-transform: uppercase;\n\t\tfont-weight: bold;\n\t\tborder-radius: 4px;\n\t\tcursor: pointer;\n\t\tmargin-right: 10px;\n\t\tmin-width: 5rem;\n\t}\n</style>"]}, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

// Declare install function executed by Vue.use()
function install(Vue) {
	if (install.installed) { return; }
	install.installed = true;
	Vue.component('PitchPrint', __vue_component__);
}

// Create module definition for Vue.use()
var plugin = {
	install: install,
};

// Auto-install when vue is found (eg. in browser via <script> tag)
var GlobalVue = null;
if (typeof window !== 'undefined') {
	GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
	GlobalVue = global.Vue;
}
if (GlobalVue) {
	GlobalVue.use(plugin);
}

export default __vue_component__;
export { install };
